import { defineStore } from 'pinia';

import { MenuInterface, BreadcrumbInterface } from '@interface/page';
import {
  RequestGetNewsList, ResponseGetNewsList, AxiosGetNewsList
} from '@server/apiNews';

export interface PageStateInterface { // 平台状态
  menu: { // 菜单
    isOpen: boolean; // 是否展开
    openKey: string[]; // 展开的Key
    selectKey: string[]; // 选择的Key
    list: MenuInterface[]; // 列表
  };
  breadcrumb: BreadcrumbInterface[]; // 面包屑
  modal: { [key: string]: { open: Function, close: Function } }; // 对话框
}

/**
 * 页面数据
 */
export default defineStore('page', {
  state: (): PageStateInterface => { // 状态
    return {
      menu: {
        isOpen: false,
        openKey: [],
        selectKey: [],
        list: [
          {
            name: '首页',
            href: $Enum.RouterEnum.Home,
            // click: (href: string) => {
            //     if ($Application.Router.currentRoute.value.fullPath === href) {
            //         scrollTo(0, 0);
            //     } else {
            //         $Application.Router.push($Enum.RouterEnum.Home);
            //     }
            // }
          },
          // {
          //   name: '应用市场',
          //   children: [
          //     {
          //       name: 'Serverless应用市场GalaxyPilot',
          //       href: $Config.Href.store
          //     }
          //   ]
          // },
          {
            name: 'SaaS服务',
            children: [
              {
                name: 'AI应用市场',
                href: $Config.Href.store
              },
              {
                name:'AI互动数字人',
                href: $Config.Href.aiavatars
              }
              // {
              //   name: 'AI应用托管',
              //   href: $Config.Href.cloud
              // }
            ]
          },
          // {
          //   name: '应用托管',
          //   children: [
          //     {
          //       name: 'Serverless应用托管平台InfraPilot',
          //       href: $Config.Href.cloud
          //     }
          //   ]
          // },
          {
            name: '产品中心',
            children: [
              {
                name: '互动数字人平台(SaaS)',
                href: $Enum.RouterEnum.ProductAidigitalHuman
              },
              {
                name: '互动数字人平台(私有化)',
                href: $Enum.RouterEnum.ProductPrivateAidigitalHuman
              },
              {
                name: 'AI应用平台AIPilot',
                href: $Enum.RouterEnum.ProductAIPilot
              },
              {
                name: 'AI托管平台InfraPilot',
                href: $Enum.RouterEnum.ProductInfraPilot
              },
              // {
              //   name: '企业云成本管家CostPilot',
              //   href: $Enum.RouterEnum.ProductCostPilot
              // },
              // {
              //   name: '云原生智能运维平台SchedulX',
              //   href: $Enum.RouterEnum.ProductSchedulX
              // },
              // {
              //   name: '云原生智能运维平台SchedulX SaaS版',
              //   href: $Enum.RouterEnum.ProductSchedulXSaaS
              // }
            ]
          },
          {
            name: '解决方案',
            point: false,
            children: [
              {
                name: '运维托管',
                href: $Enum.RouterEnum.PlanTrusteeship
              },
              {
                name: '成本优化',
                point: false,
                href: $Enum.RouterEnum.PlanCost
              },
              // {
              //   name: '咨询服务',
              //   point: false,
              //   href: $Enum.RouterEnum.Consult
              // },
              // {
              //   name: '智能运维',
              //   point: false,
              //   href: $Enum.RouterEnum.PlanOperation
              // },
              // {
              //   name: '高峰流量应对',
              //   point: false,
              //   href: $Enum.RouterEnum.PlanStable
              // },
              // {
              //   name: '东数西算',
              //   point: false,
              //   href: $Enum.RouterEnum.PlanMigrate
              // },
              // {
              //   name: '多活部署',
              //   point: false,
              //   href: $Enum.RouterEnum.PlanActive
              // }
            ]
          },
          {
            name: '资料文档',
            children: [
              {
                name: '产品手册',
                click: () => {
                  $RQ.SSO.check()
                    ? open('https://gf-files-lf.oss-cn-beijing.aliyuncs.com/%E4%BA%91%E5%8E%9F%E7%94%9F%E5%9F%BA%E7%A1%80%E6%B2%BB%E7%90%86%E5%B9%B3%E5%8F%B0SchedulX%E4%BA%A7%E5%93%81%E8%AF%B4%E6%98%8E%E4%B9%A6.pdf')
                    : $RQ.SSO.login();
                },
                children: [
                  {
                    name: 'AI应用平台AIPilot',
                    href: 'https://galaxy-future.feishu.cn/docx/F3Q4dGd9woLeKoxt3TucXtUhn6d',
                  },
                  {
                    name: 'AI托管平台InfraPilot',
                    href: 'https://galaxy-future.feishu.cn/docx/Fd1sdhN2goUMCNx9wGicoJAVn2g'
                  },
                  // {
                  //   name: '智能运维平台使用说明',
                  //   href: 'https://galaxy-future.feishu.cn/file/GiIgblCFro6klFxZcx6cdiwunHe'
                  // }
                  // {
                  //   name: 'Serverless平台InfraPilot使用说明',
                  //   href: 'https://galaxy-future.feishu.cn/docx/Fd1sdhN2goUMCNx9wGicoJAVn2g'
                  // }
                ]
              },
              // {
              //     name: '操作视频',
              //     href: 'https://space.bilibili.com/2057006251/channel/seriesdetail?sid=708260'
              // },
              {
                name: '白皮书',
                children: [
                  {
                    name: 'Serverless白皮书',
                    href: $Enum.RouterEnum.BookIndustry,
                    type: $Enum.MenuEnum.Book
                  },
                  {
                    name: 'IT成本优化白皮书',
                    href: $Enum.RouterEnum.BookCostOptimization,
                    type: $Enum.MenuEnum.Book
                  },
                  {
                    name: '运维方案白皮书',
                    href: $Enum.RouterEnum.BookDevOps,
                    type: $Enum.MenuEnum.Book
                  },
                  {
                    name: '在离线混部白皮书',
                    href: 'https://gf-files-lf.oss-cn-beijing.aliyuncs.com/%E6%98%9F%E6%B1%89%E6%9C%AA%E6%9D%A5%E5%9C%A8%E7%A6%BB%E7%BA%BF%E6%B7%B7%E9%83%A8%E6%96%B9%E6%A1%88%E7%99%BD%E7%9A%AE%E4%B9%A6.pdf'
                  }
                ]
              }
            ]
          },
          // {
          //   name: '资料文档',
          //   href: $Enum.RouterEnum.Database
          // },
          // {
          //   name: '开源社区',
          //   href: $Enum.RouterEnum.Community
          // },
          {
            name: '关于我们',
            point: false,
            children: [
              {
                name: '公司简介',
                href: $Enum.RouterEnum.About,
                point: false
              },
              {
                name: '最新动态',
                href: $Enum.RouterEnum.News,
                point: false
              }
            ]
          }
        ]
      },
      breadcrumb: [],
      modal: {}
    };
  },
  getters: { // 获取
  },
  actions: { // 方法
    /**
     * 更新菜单
     * @param {*} data 数据
     */
    updateMenu(data: any): void {
      $FN.Object.synchronize(this.menu, data);
    },
    
    /**
     * 更新面包屑
     * @param {BreadcrumbInterface[]} data 数据
     */
    updateBreadcrumb(data: BreadcrumbInterface[]): void {
      $FN.Object.synchronize(this.breadcrumb, data);
    },
    
    //----- 对话框 Start -----//
    /**
     * 更新对话框
     * @param {*} data 数据
     */
    updateModal(data: any): void {
      this.modal = data;
    },
    
    /**
     * 开启对话框
     * @param {string} name 名称
     * @param {any} data 数据
     */
    openModal(name: string, data: any = null): void {
      this.modal[name]?.open(data);
    },
    
    /**
     * 关闭对话框
     * @param {string} name 名称
     * @param {any} data 数据
     */
    closeModal(name: string, data: any = null): void {
      this.modal[name]?.close(data);
    },
    //----- 对话框 End -----//
    
    /**
     * 检查红点-解决方案
     * @param {string} router 路由
     */
    async checkPointPlan(router: string = ''): Promise<any> {
      const menu = this.menu.list.find((v: MenuInterface) => v.name === '解决方案'),
        point: any = {
          [$Enum.RouterEnum.PlanOperation]: false,
          [$Enum.RouterEnum.PlanCost]: false,
          [$Enum.RouterEnum.PlanStable]: false,
          [$Enum.RouterEnum.PlanMigrate]: false,
          [$Enum.RouterEnum.PlanActive]: false,
          [$Enum.RouterEnum.PlanTrusteeship]: true
        };
      let pointLocal: any = $FN.LocalStorage.get($Enum.StorageEnum.PointPlan);
      
      pointLocal = pointLocal
        ? JSON.parse(pointLocal)
        : {};
      Object.keys(point)
        .forEach(v => {
          if (pointLocal[v] === undefined) return;
          point[v] = pointLocal[v];
        });
      
      router !== '' && (point[router] = false);
      $FN.LocalStorage.set({
        [$Enum.StorageEnum.PointPlan]: JSON.stringify(point)
      });
      
      menu.point = Object.keys(point).some(v => point[v]);
      menu.children.forEach((v: MenuInterface) => {
        v.point = point[v.href];
      });
    },
    
    /**
     * 检查红点-最新动态
     * @param {boolean} isUpdate 是否更新
     */
    async checkPointNews(isUpdate: boolean = false): Promise<any> {
      await AxiosGetNewsList({
        page_number: 1,
        page_size: 1
      } as RequestGetNewsList)
        .then((response: any) => {
          const data: ResponseGetNewsList = response.data,
            about = this.menu.list.find((v: MenuInterface) => v.name === '关于我们');
          let point = false;
          
          if (data.code !== $Enum.CodeEnum.Normal) return;
          
          if (isUpdate) {
            $FN.LocalStorage.set({
              [$Enum.StorageEnum.PointNews]: data.data.article_data[0].article_id
            });
          } else {
            point = data.data.article_data[0].article_id !== $FN.LocalStorage.get($Enum.StorageEnum.PointNews);
          }
          
          about.children.find((v: MenuInterface) => v.name === '最新动态').point = point;
          about.point = about.children.some((v: MenuInterface) => v.point);
        });
    },
    
    /**
     * 检查红点-公司简介
     * @param {boolean} isUpdate 是否更新
     */
    async checkPointCompany(isUpdate: boolean = false): Promise<any> {
      const date = '20240110',
        about = this.menu.list.find((v: MenuInterface) => v.name === '关于我们');
      let point = false;
      
      if (isUpdate) {
        $FN.LocalStorage.set({
          [$Enum.StorageEnum.PointCompany]: date
        });
      } else {
        point = date !== $FN.LocalStorage.get($Enum.StorageEnum.PointCompany);
      }
      
      about.children.find((v: MenuInterface) => v.name === '公司简介').point = point;
      about.point = about.children.some((v: MenuInterface) => v.point);
    }
  }
});